import { useDropzone } from "react-dropzone";

export const FormFileUpload = (props) => {
  const {onDrop, fileSelected} = props;
  
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      onDrop,
      maxFiles: 5,
      maxSize: 5242880,
      accept: {
        "image/jpeg": [],
        "image/png": [],
        "text/csv": [],
        "text/plain": [],
        "application/pdf": [],
        "application/msword": [],
        "application/vnd.ms-excel": [],
      },
      multiple: true,
      disabled: fileSelected,
      acceptedFiles: "image/*,application/pdf,.doc,.xls,.xlsx,.csv",
    });

  const files = acceptedFiles.map((file) => (
    <div className="text-xs">
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li>
    </div>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => {
    return (
      <div className="text-xs">
        <li key={file.path}>
          {file.path} - {file.size} bytes
          <ul>
            {errors.map((e) => (
              <li key={e.code}>{e.message}</li>
            ))}
          </ul>
        </li>
      </div>
    );
  });

  return (
    <>
      <div className="text-xs flex flex-col items-center mt-[5px] p-[4px] border-2 rounded-sm  border-dashed border-lb-file-up-border-color bg-lb-file-up-background text-lb-file-up-font-color outline-none cursor-pointer transition-all duration-[0.24s] ease-in-out">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <p className="text-xs">Drag 'n' drop some files here, or click to select files</p>
        </div>
      </div>
      <aside>
        <p className="text-xs mt-[10px]">Files</p>
        <ul>{files}</ul>
        <p className="text-xs mt-[10px]">Rejected Files</p>
        <ul>{fileRejectionItems}</ul>
      </aside>
    </>
  );
};
